import React, { useState } from "react";
import { Accordion, Container, Row, Col } from "react-bootstrap";
import "./question.css";

const QuestionNTIME = () => {
  const [activeKeys, setActiveKeys] = useState([]);

  const handleToggle = (eventKey) => {
    setActiveKeys((prev) =>
      prev.includes(eventKey)
        ? prev.filter((key) => key !== eventKey)
        : [...prev, eventKey]
    );
  };

  return (
    <Container className="my-5">
      <h2 className="text-center mb-4 fs-40">FAQs</h2>
      <Row className="p-4">
        <Col lg={6}>
          <Accordion activeKey={activeKeys}>
            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="0"
              onClick={() => handleToggle("0")}
            >
              <Accordion.Header as="h3" className="red-header">
              What are NiTime aligners?
              </Accordion.Header>
              <Accordion.Body>
              NiTime aligners are a discreet, removable orthodontic treatment designed to straighten your teeth - and the best part is you only need to wear them at night!
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="1"
              onClick={() => handleToggle("1")}
            >
              <Accordion.Header as="h3" className="red-header">
              How do NiTime aligners work?
              </Accordion.Header>
              <Accordion.Body>
              NiTime aligners gently move your teeth into the desired position while you sleep, offering a comfortable and convenient way to achieve a beautifully straighter smile with minimal daytime wear.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="2"
              onClick={() => handleToggle("2")}
            >
              <Accordion.Header as="h3" className="red-header">
              How many hours a day do I need to wear NiTime aligners?
              </Accordion.Header>
              <Accordion.Body>
              You only need to wear NiTime aligners for around at least 12 hours each day, mainly during the evening and overnight, making them perfect for busy lifestyles.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="3"
              onClick={() => handleToggle("3")}
            >
              <Accordion.Header as="h3" className="red-header">
              Are NiTime aligners suitable for everyone?
              </Accordion.Header>
              <Accordion.Body>
              NiTime aligners are ideal for mild to moderate orthodontic cases. We’ll assess your smile at your consultation to see if you’re a good candidate.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="9"
              onClick={() => handleToggle("9")}
            >
              <Accordion.Header as="h3" className="red-header">
              How do I get started with NiTime aligners at Regent Dental?
              </Accordion.Header>
              <Accordion.Body>
              Booking a consultation is easy - just get in touch with us! We’ll assess your smile, discuss your goals, and create a tailored treatment plan to help you achieve your dream smile with NiTime.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>

        <Col lg={6}>
          <Accordion activeKey={activeKeys}>
            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="4"
              onClick={() => handleToggle("4")}
            >
              <Accordion.Header as="h3" className="red-header">
              How long does treatment with NiTime aligners take?
              </Accordion.Header>
              <Accordion.Body>
              Treatment times vary depending on your individual case, but most patients complete their journey to a straighter smile in as little as 6–18 months.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="5"
              onClick={() => handleToggle("5")}
            >
              <Accordion.Header as="h3" className="red-header">
              Will NiTime aligners affect my speech?
              </Accordion.Header>
              <Accordion.Body>
              Because you wear them mainly while sleeping, any minor adjustment to your speech is usually minimal and short-lived.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="6"
              onClick={() => handleToggle("6")}
            >
              <Accordion.Header as="h3" className="red-header">
              Are NiTime aligners comfortable to wear?
              </Accordion.Header>
              <Accordion.Body>
              Yes! NiTime aligners are custom-made to fit your teeth precisely, so they are smooth, comfortable, and easy to wear throughout the night.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="7"
              onClick={() => handleToggle("7")}
            >
              <Accordion.Header as="h3" className="red-header">
              Can I eat and drink with NiTime aligners in?
              </Accordion.Header>
              <Accordion.Body>
              We recommend removing your aligners before eating or drinking anything other than water. This helps protect both your aligners and your teeth.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="8"
              onClick={() => handleToggle("8")}
            >
              <Accordion.Header as="h3" className="red-header">
              How do I keep my aligners clean?
              </Accordion.Header>
              <Accordion.Body>
              Simply rinse them with cool water and gently brush them with a soft toothbrush daily. We’ll also share our top tips for keeping them fresh and clear.
              </Accordion.Body>
            </Accordion.Item>
            
          </Accordion>
        </Col>
      </Row>
    </Container>
  );
};

export default QuestionNTIME;
